/* src/app/contract-calculation/contract-calculation-list/contract-calculation-list.component.css */
:host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
:host ::ng-deep .p-datatable .p-datatable-thead > tr > th.rebate-col {
  max-width: 18rem;
  width: 18rem;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
:host ::ng-deep .p-datatable .p-datatable-tbody > tr > td.rebate-col {
  max-width: 18rem;
  width: 18rem;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
:host ::ng-deep .rebate-cell-content {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}
:host ::ng-deep .rebate-save-btn {
  width: 8rem;
}
.old-claim-info {
  color: #d32f2f;
  font-size: 0.85rem;
  margin-top: 0.25rem;
}
/*# sourceMappingURL=contract-calculation-list.component-CBIE6PBD.css.map */
